<div class="inner-content">
  <nz-breadcrumb>
    <nz-breadcrumb-item>首页</nz-breadcrumb-item>
    <nz-breadcrumb-item>诊断模板</nz-breadcrumb-item>
    <nz-breadcrumb-item>诊断模板</nz-breadcrumb-item>
  </nz-breadcrumb>
  <nz-tabset nzLinkRouter>
    <nz-tab>
      <a *nzTabLink nz-tab-link [routerLink]="['/admin/setting/print']"> 打印模板 </a>
    </nz-tab>
    <nz-tab>
      <a *nzTabLink nz-tab-link [routerLink]="['/admin/setting/diagnosis']"> 诊断模板 </a>
    </nz-tab>
  </nz-tabset>
  <div class="main-container">
    <div class="sider">
      <div class="top tabs">
        <div class="tabs-item" [ngClass]="{ 'tabs-item-active': templateType === 'SYSTEM' }" (click)="selectTab('SYSTEM'); getTemplate()">系统模板</div>
        <div class="tabs-item" [ngClass]="{ 'tabs-item-active': templateType === 'HOSPITAL' }" (click)="selectTab('HOSPITAL'); getTemplate()">医院模板</div>
        <div class="tabs-item" [ngClass]="{ 'tabs-item-active': templateType === 'PERSONAL' }" (click)="selectTab('PERSONAL'); getTemplate()">个人模板</div>
      </div>
      <div class="tree-list">
        <div class="search-box" style="padding: 0 10px 10px 0">
          <nz-input-group [nzSuffix]="suffixIcon">
            <input type="text" nz-input placeholder="请输入关键字" [(ngModel)]="keyword" />
          </nz-input-group>
          <ng-template #suffixIcon>
            <button nz-button nzType="link" nzSize="small" (click)="search()">搜索</button>
            <button nz-button nzType="link" nzSize="small" (click)="reset()">重置</button>
          </ng-template>
        </div>
        <nz-tree #nzTreeComponent [nzData]="nodes" nzShowLine (nzClick)="selectNode($event)" [nzTreeTemplate]="nzTreeTemplate" [nzExpandedKeys]="expandedKeys"></nz-tree>
      </div>
    </div>
    <div class="content">
      <div class="template-form">
        <div class="form-item">
          <div class="label">模板名称</div>
          <div class="input">
            <input nz-input [(ngModel)]="templateName" placeholder="请输入模板名称" />
          </div>
        </div>
        <div class="form-item">
          <div class="label">扫描方法</div>
          <div class="input">
            <input nz-input [(ngModel)]="scanMethod" placeholder="请输入扫描方法" />
          </div>
        </div>
        <div class="form-item">
          <!-- 保存 -->
          <button nz-button nzType="primary" (click)="saveTemplate()" [disabled]="!canSaveTemplate()">保存</button>
        </div>
      </div>
      <div class="main">
        <div class="main-left">
          <div class="main-left-item">
            <div class="m_title">
              <div class="title-text">影像学所见</div>
              <div class="action">
                <button nz-button nzType="link" nzSize="small" (click)="addOption('finding', '[选项1/选项2]')">
                  <span nz-icon nzType="plus" nzTheme="outline"></span>
                  选项
                </button>
                <button nz-button nzType="link" nzSize="small" (click)="addOption('finding', '[_]')">
                  <span nz-icon nzType="plus" nzTheme="outline"></span>
                  填空
                </button>
                <button nz-button nzType="link" nzSize="small" (click)="addOption('finding', '[@]')">
                  <span nz-icon nzType="plus" nzTheme="outline"></span>
                  引用
                </button>
              </div>
            </div>
            <div class="m_content">
              <!-- textarea -->
              <textarea nz-textarea id="findingContent" [(ngModel)]="findingContent" placeholder="请输入内容" (ngModelChange)="contentChange()" rows="10"></textarea>
            </div>
          </div>
          <div class="main-left-item">
            <div class="m_title">
              <div class="title-text">影像学结论</div>
              <div class="action">
                <button nz-button nzType="link" nzSize="small" (click)="addOption('conclusion', '[选项1/选项2]')">
                  <span nz-icon nzType="plus" nzTheme="outline"></span>
                  选项
                </button>
                <button nz-button nzType="link" nzSize="small" (click)="addOption('conclusion', '[_]')">
                  <span nz-icon nzType="plus" nzTheme="outline"></span>
                  填空
                </button>
                <button nz-button nzType="link" nzSize="small" (click)="addOption('conclusion', '[@]')">
                  <span nz-icon nzType="plus" nzTheme="outline"></span>
                  引用
                </button>
              </div>
            </div>
            <div class="m_content">
              <!-- textarea -->
              <textarea nz-textarea id="conclusionContent" [(ngModel)]="conclusionContent" placeholder="请输入内容" (ngModelChange)="contentChange()" rows="10"></textarea>
            </div>
          </div>
        </div>
        <div class="main-right">
          <div class="main-right-item">
            <div class="m_title">
              <div class="title-text">模版预览</div>
            </div>
            <div class="m_content preview-container">
              <div class="t">
                <h3>影像学所见:</h3>
              </div>
              <div class="preview-content" #findingPreview id="findingPreview">
                <app-template-render [template]="preview.finding" [value]="reportValue" (reportChange)="onValueChange($event, 'finding')" (valueChange)="reportValueChange($event)"></app-template-render>
              </div>
              <div class="t">
                <h3>影像学结论:</h3>
              </div>
              <div class="preview-content" #conclusionPreview id="conclusionPreview">
                <app-template-render [template]="preview.conclusion" [value]="reportValue" (reportChange)="onValueChange($event, 'conclusion')" (valueChange)="reportValueChange($event)"></app-template-render>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #nzTreeTemplate let-node let-origin="origin">
  <span class="custom-node">
    <span *ngIf="!node.isLeaf">
      <span class="folder-name">{{ node.title }}</span>
      <span class="folder-desc">
        <button nz-button nzType="link" nzSize="small" (click)="addFolder(node, folderModal)">
          <span nz-icon nzType="plus"></span>
        </button>
        <button nz-button nzType="link" nzSize="small" (click)="deleteItem(node)">
          <span nz-icon nzType="delete"></span>
        </button>
      </span>
    </span>
    <span *ngIf="node.isLeaf">
      <span class="file-name">{{ node.title }}</span>
      <span class="file-desc">
        <!-- edit -->
        <button nz-button nzType="link" nzSize="small" (click)="copyItem(node)">
          <span nz-icon nzType="copy"></span>
        </button>
        <!-- delete -->
        <button nz-button nzType="link" nzSize="small" (click)="deleteItem(node)">
          <span nz-icon nzType="delete"></span>
        </button>
      </span>
    </span>
  </span>
</ng-template>
<ng-template #folderModal let-modal>
  <div nz-row>
    <div nz-col nzFlex="140px">
      <!-- 目录还是词条 -->
      <nz-radio-group [(ngModel)]="folderType">
        <label nz-radio-button nzValue="folder">目录</label>
        <label nz-radio-button nzValue="item">词条</label>
      </nz-radio-group>
    </div>
    <div nz-col nzFlex="auto">
      <input nz-input placeholder="请输入名称" [(ngModel)]="folderName" />
    </div>
  </div>
</ng-template>
